import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { doc, docData, Firestore } from "@angular/fire/firestore";
import { Player } from "../model/broadcast/player";

// Reads the per-team roster (with jersey numbers) that ball-score-server scrapes
// from WBSC into the `leagues/{leagueId}/rosters/{teamId}` subcollection
// (teamId = TeamDefaultConfig.id). Replaces WbscService.fetchFullRoster.
@Injectable({
  providedIn: 'root'
})
export class RostersService {

  constructor(
    private firestore: Firestore,
  ) { }

  getRoster(leagueId: string, teamId: string): Observable<Player[]> {
    const documentReference = doc(this.firestore, `leagues/${leagueId}/rosters/${teamId}`);
    return (docData(documentReference) as Observable<{ players?: Player[] }>).pipe(
      map(doc => doc?.players ?? []),
    );
  }
}
